import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=685870b6&"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports